import axois from "axios";
import sender from "./sender";

// IDOM project service
export class OracleApiService {
  get url() {
    return "/api/oracle";
  }

  constructor(host) {
    this.http = axois.create({
      baseURL: host,
    });
  }

  get(method, params, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restGet(path, params, headers);
  }

  post(method, body, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restPost(path, body, headers);
  }

  // ===========================================================
  // tlgrm reactions flow
  // ===========================================================
  get_queue_messages(queue, filter, count = 25, page = 1) {
    const method = "queue/get";
    const body = { queue, count, filter, page, sort: "backward" };
    return this.post(method, body);
  }

  get_subscribers(peer_guid) {
    return this.post("meta/subscribers", {
      peer_guid,
    });
  }
  accept_queue_message(guid) {
    const method = "queue/premoderate";
    const body = { guid };
    return this.post(method, body);
  }
  push_queue_message(guid, queue, text, cache_key) {
    const method = "queue/accept_instantly";
    const body = { guid, queue, text, cache_key };
    return this.post(method, body);
  }
  decline_queue_message(guid, queue) {
    const method = "queue/del";
    const body = { guid, queue };
    return this.post(method, body);
  }

  queue_accept_instantly(body) {
    return this.post("queue/accept/instantly", body);
  }
  queue_premoderate_user(body) {
    return this.post("queue/premoderate/user", body);
  }
  reload_oracle() {
    const method = "clear_cache";
    return this.post(method, {});
  }
  update_settings(settings) {
    const method = "panic/premoderate";
    return this.post(method, {
      settings,
    });
  }
  // ===========================================================
  // messages
  // ===========================================================
}
